import { html, LitElement, TemplateResult } from 'lit';
import { property, query, state } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { ButtonColor, ButtonFill, ButtonSize, ButtonType, FontSize } from '../../gzIconButton/types';
import { classMap } from 'lit/directives/class-map.js';
import IconSet from '../../gzIcon/GzIconSet';

export class GzIconButtonWebComponent extends LitElement {
  @property({ type: String, reflect: true })
  icon = '';

  @property({ type: Boolean, reflect: true })
  disabled = false;

  @property({ type: Boolean, reflect: true })
  active = false;

  /**
   * The default button size is 24px.
   */
  @property({ type: String, reflect: true })
  size: ButtonSize = ButtonSize.SIZE_24;

  /**
   * The default icon font size is 15px.
   */
  @property({ type: String, reflect: true })
  fontSize: FontSize = FontSize.ICON_SIZE_15;

  /**
   * The default icon shape is rounded
   */
  @property({ type: String, reflect: true })
  buttonType: ButtonType = ButtonType.ROUND;

  /**
   * The default icon background is transparent
   */
  @property({ type: String, reflect: true })
  buttonFill: ButtonFill = ButtonFill.QUIET;

  /**
   * The default tooltip text is empty.
   */
  @property({ type: String, reflect: true })
  tooltipText: string;

  /**
   * The default icon color is blue
   */
  @property({ type: String, reflect: true })
  buttonColor: ButtonColor = ButtonColor.PRIMARY;

  @property({ type: Boolean, reflect: true })
  showSpinner = false;

  @query('button')
  button: HTMLElement;

  @state()
  private iconSetInstance: IconSet;

  constructor() {
    super();
    this.addEventListener('click', this.clickHandler);
    this.iconSetInstance = IconSet.getInstance();
  }

  private clickHandler(e: Event) {
    if (this.disabled) {
      e.stopImmediatePropagation();
    }
  }

  static get styles() {
    return styles;
  }

  render() {
    return html`${this.tooltipText ? this.renderIconBtnWithTooltip() : this.renderIconBtn()}`;
  }

  private renderSpinner() {
    return html`<gz-progress-spinner class="button-spinner" spinnerwidth="small"</gz-progress-spinner> `;
  }

  private renderIconBtn() {
    const classes = {
      ['btn-color--' + this.buttonColor]: this.buttonColor,
      ['btn-fill--' + this.buttonFill]: this.buttonFill,
      ['btn-type--' + this.buttonType]: this.buttonType,
    };

    return html`<button
      class="icon-btn ${classMap(classes)}"
      ?disabled="${this.showSpinner ? this.showSpinner : this.disabled}"
      part="button"
    >
      ${this.showSpinner ? this.renderSpinner() : this.renderIconElement()}
    </button>`;
  }

  private renderIconBtnWithTooltip() {
    return html` <gz-tooltip class="tooltip" tooltipText="${this.tooltipText}"> ${this.renderIconBtn()} </gz-tooltip> `;
  }

  private renderIconElement(): TemplateResult {
    if (this.iconSetInstance.isSVGIconAvailable(this.icon)) {
      return html`<gz-icon .name="${this.icon}" .size="${this.fontSize}" .color="${this.buttonColor}"></gz-icon>`;
    } else {
      return html`<span class="${this.icon}"></span>`;
    }
  }
}
